import { voiceApi } from '@/lib/api';
export const voiceSocketDependencies = {
  voiceApi,
  loadVoiceVision: () => require('@/lib/voiceVision').default,
  loadVoiceMode: () => require('@/lib/voiceMode').default,
  voiceModeStore: { getState: () => require('@/store').useVoiceModeStore.getState() },
  authStore: { getState: () => require('@/store').useAuthStore.getState() },
  chatStore: { getState: () => require('@/store').useChatStore.getState() },
};
